(function () {
  var MODAL_ID = "sparePartNotice";
  var STORAGE_KEY = "sparepart_notice_hide_until";
  var HIDE_DAYS = 7;

  function isHiddenByUser() {
    try {
      var until = localStorage.getItem(STORAGE_KEY);
      if (!until) return false;
      return Date.now() < parseInt(until, 10);
    } catch (e) {
      return false;
    }
  }

  function setHiddenForDays(days) {
    try {
      var until = Date.now() + days * 24 * 60 * 60 * 1000;
      localStorage.setItem(STORAGE_KEY, String(until));
    } catch (e) {}
  }

  function openModal(modal) {
    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");
    document.documentElement.style.overflow = "hidden";
  }

  function closeModal(modal) {
    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");
    document.documentElement.style.overflow = "";
  }

  document.addEventListener("DOMContentLoaded", function () {
    var modal = document.getElementById(MODAL_ID);
    if (!modal) return;

    if (isHiddenByUser()) return;

    // Slight delay so it doesn't feel like an intrusive "alert"
    setTimeout(function () {
      openModal(modal);
    }, 600);

    // Close handlers (X, backdrop, button)
    modal.addEventListener("click", function (e) {
      if (e.target && e.target.hasAttribute("data-sparepart-close")) {
        var cb = document.getElementById("sparepartDontShow");
        if (cb && cb.checked) setHiddenForDays(HIDE_DAYS);
        closeModal(modal);
      }
    });

    // ESC to close
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && modal.classList.contains("is-open")) {
        var cb = document.getElementById("sparepartDontShow");
        if (cb && cb.checked) setHiddenForDays(HIDE_DAYS);
        closeModal(modal);
      }
    });
  });
})();
